<template>
<div class="w100">
  <!-- <transition name="modal-fade"> -->
    <div class="modal-backdrop" v-on:click="ClickOutside()">
    </div>
    <div class="modal" role="dialog" >
      <header class="modal-header" id="modalTitle" >
        <slot name="header">
          <div ref="Titulo">Nuevo registro</div>
        </slot>
      </header>
      <section class="modal-body mT10" id="modalDescription" >
          
        <div class="face face-front oHidden">
          <div class="content aliCenter">
            <!-- <div class="TituloLogin B">Login</div> -->
            <div class="">
              <div class="field-wrapper">
                <input v-model="Valor" type="number" placeholder="Valor" ref="Valor" />
                <label>Valor</label>
              </div>
              <!-- <div class="field-wrapper">
                <input v-model="FechaAlta._Fecha" type="text" placeholder="Valor" />
                <label>Fecha</label>
              </div> -->
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-footer">
          <button type="button" class="Boton BotonCancelar" @click="Cerrar" >Cancelar</button>
          <button type="button" class="Boton BotonAceptar" @click="Aceptar()" >Aceptar</button>
      </footer>
    </div>
  <!-- </transition> -->
  
</div>
</template>
<script>
  import Clases from "../../Auxiliares/Clases.js";
  import ManejoDatos from "../../Auxiliares/ManejoDatos.js";
  export default {
    name: 'ModalNuevoEstablecimiento',
    data() {
      return {
        FechaAlta: new Clases.Fecha(),
        Valor: "",
        _IdPluviometro: 0
      };
    },
    mounted() {
    },
    created(){

    },
    methods: {
      Setear(_IdPluviometro){
        this._IdPluviometro = _IdPluviometro;
      },
      Cerrar() {
        this.$emit('Cerrar');
      },
      ClickOutside(){
        this.$emit('Cerrar');
      },
      async Aceptar() {
        try {
          // alert(new Clases.Fecha().Paquete());
          // return;

          await this.SolicitoAltaRegistroPluviometro();
          this.LimpiarDatos();
          this.$parent.CerrarModal();
          this.$parent.RefrescarInfo(this._IdPluviometro);
        } catch (error) {
          console.log(error);
        }
      },
      async SolicitoAltaRegistroPluviometro(){
        try {
          var _Par = {
            IdUsuario: this.$parent.$parent.Datos._User._ID,
            IdPluviometro: this._IdPluviometro,
            Valor: parseInt(this.Valor),
            Fecha: new Clases.Fecha().Paquete()
          };
          await ManejoDatos.IntentoAltaRegistroPluviometro(_Par, true, this.$parent.$parent);
        } catch (error) {
          console.error(error);
        }
      },
      LimpiarDatos(){
        this.Valor = "";
      }
    }
  };
</script>
<style lang="scss" scoped>
    $AgroIdeas: #005625;
    $text-dark: #444;
    $navy-blue: #999;
    
    .face {
        width: 100%;
        padding: 0px 10px;
        box-sizing: border-box;

        .content {
            color: $text-dark;
            h2 {
            font-size: 1.2em;
            color: $AgroIdeas;
            }
            .field-wrapper {
            margin-top: 20px;
            position: relative;

            label {
                position: absolute;
                pointer-events: none;
                font-size: 0.85em;
                top: 40%;
                left: 0;
                transform: translateY(-5px);
                transition: all ease-in 0.25s;
                color: lighten($text-dark, 20%);
            }
            input,
            textarea {
                -webkit-appearance: none;
                appearance: none;
                &:focus {
                outline: none;
                }
            }
            input,
            textarea {
                width: 100%;
                border: none;
                background: transparent;
                line-height: 2em;
                border-bottom: 1px solid $AgroIdeas;
                color: $text-dark;

                &::-webkit-input-placeholder {
                opacity: 0;
                }
                &::-moz-placeholder {
                opacity: 0;
                }
                &:-ms-input-placeholder {
                opacity: 0;
                }
                &:-moz-placeholder {
                opacity: 0;
                }
                &:focus,
                &:not(:placeholder-shown) {
                + label {
                    top: -35%;
                    color: $navy-blue;
                }
                }
            }
            textarea {
                resize: none;
                line-height: 1em;
                &:focus,
                &:not(:placeholder-shown) {
                + label {
                    top: -25%;
                }
                }
            }
            }
        }
    }


    .modal-fade-enter, .modal-fade-leave-active {
        opacity: 0;
    }
    .modal-fade-enter-active, .modal-fade-leave-active {
        transition: opacity .2s ease
    }
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 11;
    }
    .modal {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px #222;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        width: 95%;
        max-width: 500px;
        
        position: fixed;
        justify-content: center;
        z-index: 12;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
        // border-top: 1px solid #eeeeee;
        justify-content: space-between;
    }
    .modal-header {
        border-bottom: 1px solid #eeeeee;
        font-weight: bold;
        background: rgba(0,0,0,0.8);
        color: #CCC;
    }
    .modal-footer {
        margin-top:20px;
    }
    .Boton{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        width: 100px;
        line-height: 2em;
        color: #fff;
        border: 1px solid #000;
        border-radius: 3px;
        padding: 5px;
        &:hover {
            opacity: 0.9;
        }
        &:active {
            transform: scale(0.96);
        }
    }
    .BotonCancelar {  
        background: #999;
    }
    .BotonAceptar {  
        background: $AgroIdeas;
    }
</style>